import React, { memo } from "react";
// import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { FormMain } from "./styles/FormMainStyle";
import AuthInput from "../../shared/authinput";
// import MainButton from "../../shared/Button";

const ReceiverDetails = ({ data = {} }) => {
  // const validationSchema = Yup.object().shape({
  //   ContactName: Yup.string().required("Contact name is required"),
  //   email: Yup.string().email("Invalid email").required("Email is required"),
  //   PhoneNumber: Yup.number().required("Phone number is required"),
  //   Addresslocation: Yup.string().required("Address / location   is required"),
  // });
  const initialValues = {
    ContactName: data?.contact_name || "",
    email: data?.email || "",
    PhoneNumber: data?.phone_number || "",
    Addresslocation: data?.location?.address || "",
  };
  return (
    <>
      <FormMain>
        <Formik
          initialValues={initialValues}
          // validationSchema={validationSchema}
          onSubmit={(values) => {
            // handle form submission here
            // console.log("values", values);
          }}
        >
          {(formik) => (
            <Form autocomplete="off">
              <Field
                type="text"
                name="ContactName"
                label="Contact Name"
                component={AuthInput}
                placeholder="Enter your Contact Name"
                disabled
              />
              <Field
                type="email"
                name="email"
                label="Email Address"
                component={AuthInput}
                placeholder="Enter your Email Address"
                disabled
              />
              <Field
                type="text"
                name="PhoneNumber"
                label="Phone Number"
                component={AuthInput}
                placeholder="Enter your Phone Number"
                disabled
              />
              <Field
                type="text"
                name="Addresslocation"
                label="Address / location "
                component={AuthInput}
                placeholder="Enter your Address / location"
                disabled
              />
              {/* <MainButton type="submit" label="Edit Receiver Details" MT="90" /> */}
            </Form>
          )}
        </Formik>
      </FormMain>
    </>
  );
};

export default memo(ReceiverDetails);
